import { generateMarketPathname } from '@chewy/market-handler';
import Image from 'next/image';

import LeftQuotation from '@/images/left-quote.svg';
import RightQuotation from '@/images/right-quote.svg';

import styles from './QuoteSlide.module.scss';
export const QuoteSlide = ({
  quote,
  author,
  market,
}: {
  quote: string;
  author: string;
  market: string;
}) => (
  <div className={`keen-slider__slide ${styles.slide}`}>
    <div className={styles.quoteBlockContainer}>
      <div className={styles.quoteBlock}>
        <div className={styles.leftQuote}>
          <Image
            alt="left quotation mark"
            className={styles.quotationMark}
            height={20}
            src={generateMarketPathname(LeftQuotation.src, market)}
            width={20}
          />
        </div>
        <p className={styles.quoteText}>{quote}</p>
        <div className={styles.rightQuote}>
          <Image
            alt="right quotation mark"
            className={styles.quotationMark}
            height={20}
            src={generateMarketPathname(RightQuotation.src, market)}
            width={20}
          />
        </div>
      </div>

      <p className={styles.quoteAuthor}>{author}</p>
    </div>
  </div>
);
